export default "__VITE_ASSET__Cx9ASk9n__"